export const APP_TYPE = {
  AI_ASSISTANT: 'ai_assistant',
  RECEIPTS: 'receipts',
  DOCUMENT_SIGNATURE: 'document_signature',
  BILLING: 'billing_app',
  PAYMENTS: 'payments',
  CALENDAR_SYNC: 'calendar_sync',
  COMMUNICATION: 'communication',
};

// Hardcoded removals for the market slice (mirrors core's get_available_market_apps).
export const MARKET_EXCLUDED_CODES = [
  'paypalprovider',
  'documents',
  'old_integration_square',
  'old_integration_stripe',
  'paypalwallet',
];

export const ASSIGNMENT_TYPE = {
  INSTALLED: 'installed',
  DIRECTORY_OFFERING: 'directory_offering',
  INTERNAL: 'internal',
};
